import React from 'react';
import { Table, Avatar, Badge, Button } from '@/components/ui';
import type { ConstructionReworkOrder } from '../types/construction-rework.types';
import { ReworkStatusBadge } from './ReworkStatusBadge';
import { useNavigate } from 'react-router-dom';

interface Props {
  data: ConstructionReworkOrder[];
  isLoading?: boolean;
}

export const ReworkTable: React.FC<Props> = ({ data, isLoading }) => {
  const navigate = useNavigate();

  const columns = [
    { key: 'rework_code', title: 'Mã lệnh', width: '120px' },
    { key: 'title', title: 'Nội dung sửa lỗi' },
    { key: 'project', title: 'Dự án / Khu vực' },
    { key: 'team', title: 'Đội thi công' },
    { key: 'assignee', title: 'Người xử lý' },
    { key: 'status_code', title: 'Trạng thái', width: '140px' },
    { key: 'actions', title: '', width: '80px', align: 'right' as const },
  ];

  return (
    <Table
      columns={columns}
      data={data}
      isLoading={isLoading}
      renderCell={(row, key) => {
        if (key === 'rework_code') return <span className="text-xs font-bold text-os-primary">{row.rework_code}</span>;
        if (key === 'title') return (
          <div className="space-y-1">
            <p className="text-xs font-bold text-slate-900">{row.title}</p>
            <p className="text-[10px] text-slate-500 line-clamp-1">{row.description}</p>
          </div>
        );
        if (key === 'project') return (
          <div className="space-y-1">
            <p className="text-xs text-slate-700">{row.project?.name}</p>
            <p className="text-[10px] text-slate-400">{row.zone?.name}</p>
          </div>
        );
        if (key === 'team') return <span className="text-xs text-slate-600 font-medium">{row.team?.name}</span>;
        if (key === 'assignee') return (
          <div className="flex items-center gap-2">
            <Avatar src={row.assignee?.avatar_url} fallback={row.assignee?.full_name?.charAt(0)} size="xs" />
            <span className="text-[10px] font-bold text-slate-700">{row.assignee?.full_name}</span>
          </div>
        );
        if (key === 'status_code') return <ReworkStatusBadge status={row.status_code} />;
        if (key === 'actions') return (
          <Button
            variant="ghost"
            size="xs"
            icon="ri-arrow-right-line"
            onClick={() => navigate(`/construction/rework/detail/${row.id}`)}
          />
        );
        return null;
      }}
    />
  );
};
